import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-sans font-semibold tracking-[0.02em] cursor-pointer transition-all duration-200 hover:opacity-90 active:scale-[0.97] disabled:opacity-50 disabled:pointer-events-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-green/60",
  {
    variants: {
      variant: {
        primary: "bg-green text-white",
        outline: "bg-transparent text-green border-[1.5px] border-green",
        red: "bg-red text-white",
        gold: "bg-gold text-white",
        ghost: "bg-transparent text-green hover:bg-green-light",
      },
      size: {
        default: "text-sm px-6 py-[11px]",
        sm: "text-[13px] px-[22px] py-[10px]",
        lg: "text-[15px] px-7 py-[13px]",
        block: "w-full text-[15px] py-[13px]",
      },
    },
    defaultVariants: { variant: "primary", size: "default" },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  )
);
Button.displayName = "Button";

export { Button, buttonVariants };
